import type {Output} from './Configuration';

export const INVALID_TARGET_LANGUAGE_MESSAGE =
    'The target language must be different from the input language. Please select another target language.';

export function getTargetLanguageValidationError(
    inputLanguageKey: string,
    outputs: Output[]
): Error | null {
    if (outputs.length === 0 || outputs.some(output => output.language.translationKey !== inputLanguageKey)) {
        return null;
    }

    return new Error(INVALID_TARGET_LANGUAGE_MESSAGE);
}
